module.exports = __webpack_public_path__ + "img/slider_1.46dbcc30.jpg";